// extracted by mini-css-extract-plugin
export var fadeInOut = "_27-3";
export var icon = "_27-4";
export var savedIndicator = "_27-2";
export var savingIndicator = "_27-0";
export var spin = "_27-1";